import loadable from "@loadable/component";

const OverviewComponent = loadable(() => {
  return import("../components/Overview") as unknown as Promise<React.FC>;
});

const Overview = () => {
  return <OverviewComponent />;
};

export default Overview;
